import { render, staticRenderFns } from "./leads_activities.vue?vue&type=template&id=2b1a5edc&"
import script from "./leads_activities.vue?vue&type=script&lang=js&"
export * from "./leads_activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports